import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Tag = ({
	title,
	url,
	target,
	theme,
	textTheme,
	className,
	onClick,
	active,
	bold,
	size,
	next
}) => {
	const tagCx = cx(
		styles.tag,
		{
			[styles.active]: active,
			[styles.bold]: bold
		},
		styles[`theme_${theme}`],
		styles[`size_${size}`],
		styles[`textTheme_${textTheme}`],
		className
	);

	return url || next ? (
		<NextLink
			href={url}
			className={tagCx}
			target={target}
			rel={target ? 'noopener' : ''}
			next={next}
		>
			<span className={styles.text}>{title}</span>
		</NextLink>
	) : (
		<button type="button" className={tagCx} onClick={onClick}>
			<span className={styles.text}>{title}</span>
		</button>
	);
};

Tag.propTypes = {
	title: PropTypes.string.isRequired,
	url: PropTypes.string,
	active: PropTypes.bool,
	target: PropTypes.oneOf(['_blank']),
	theme: PropTypes.oneOf(['bright', 'transparent', 'bordered', 'tab']),
	textTheme: PropTypes.oneOf(['dark', 'light']),
	size: PropTypes.oneOf(['narrow']),
	bold: PropTypes.bool,
	onClick: PropTypes.func,
	className: PropTypes.string,
	next: PropTypes.bool
};

Tag.defaultProps = {
	active: false,
	bold: true
};

export default Tag;
